<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
    <v-app-bar-nav-icon @click="drawMenu"></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <v-img
          alt="MovieShareLogo"
          class="shrink mr-2"
          contain
          src="./assets/logo_movie.png"
          transition="scale-transition"
          width="40"
        />
      </div>
      <v-spacer></v-spacer>
      <v-avatar style="cursor: pointer" color="grey" tile @click="show"
      v-if="user.displayName!='' && user.displayName!=null">
        <v-container
          v-if="user.photoURL===null || user.photoURL==''">
            {{getInitials()}}
        </v-container>
        <v-img v-else
        :src="user.photoURL"></v-img></v-avatar>
      <v-menu
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y>
        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>{{this.user.displayName}}(Logout)</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn @click="showLoginAndHide()" v-if="false">Entrar</v-btn>
    </v-app-bar>
    <NavMenu @onOpenModalHelp="OpenModalHelp" v-model="drawerMenu"/>
    <MovieHelp v-model="modalMovieHelp"/>
    <v-content>
      <Login/>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Login from './components/Login.vue';
import NavMenu from './components/NavMenu.vue';
import MovieHelp from './components/MoviesHelp.vue';

export default {
  name: 'App',
  metaInfo: {
    title: 'Movielist - Compartilhe suas séries e filmes favoritos da Amazon Prime e Netflix',
  },
  components: {
    Login,
    NavMenu,
    MovieHelp,
  },
  data: () => ({
    languages: [
      { title: 'Português' },
      { title: 'English' },
    ],
    offset: true,
    language: 'Português',
    user: { displayName: '', photoURL: '' },
    showMenu: false,
    y: 0,
    x: 0,
    showlogin: false,
    drawerMenu: false,
    modalMovieHelp: false,
  }),
  created() {
    this.$auth.onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    });
  },
  methods: {
    OpenModalHelp() {
      this.drawerMenu = false;
      this.modalMovieHelp = true;
    },
    drawMenu() {
      this.drawerMenu = true;
    },
    showLoginAndHide() {
      this.showlogin = !this.showlogin;
      console.log(this.showlogin);
      Login.showbuttons = this.showlogin;
    },
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    logout() {
      this.$firebase.auth().signOut().then(() => {
        console.log('logout');
        this.$router.push(this.$route.path);
      }).catch((error) => {
        alert(`Falha no Logout:${error}`);
      });
    },
    getInitials() {
      let initials = '';
      if (this.user.displayName === null) {
        return ':X';
      }
      let i = 0;
      this.user.displayName.split(' ').forEach((word) => {
        if (i <= 1) initials += word.substring(0, 1);
        i += 1;
      });
      return initials;
    },
  },
};
</script>
